/* eslint-disable camelcase */

/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Strengths from '../../../assets/Brain.png';
import Goals from '../../../assets/Vector.png';
import DiscussionLogs from '../../../assets/friend.png';
import MetricReview from '../../../assets/graph.png';
import { ROLES, TOOLTIPDISCUSSION, TOOLTIPMETRIC, TOOLTIPSTRENGTH } from '../../../constants';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../../pages/login/authSlice';
import { getRole } from '../../../utils/roleUtils';
import { CoachingEntityTypes, CoachingTabs } from '../../../utils/typeConstants';
import NewConversationLog from '../conversationLogs/newConversationLog/NewConversationLog';
import ReadConversationLog from '../conversationLogs/readConversationLog/ReadConversationLog';
import MetricModal from '../metrics/MetricModal';
import { RevGenSummary } from '../revGen/RevGenSummary';
import { useGetRevGenCoachingGoalQuery } from '../revGen/revGenSlice';
import { SearchedEmployeType } from '../revGen/type';
import NewStrength from '../strengths/newStrength/NewStrength';
import ReadStrengths from '../strengths/readStrengths/ReadStrengths';
import { StrengthList } from '../strengths/types';
import UpdateStrength from '../strengths/updateStrength/UpdateStrength';
import { ActivityEmployeeSearchPopUp } from './ActivityEmployeeSearch';
import './coachingHistoryGrid.scss';
import {
    useGetActivitySummaryQuery,
    useGetCurrentMonthAcitivityQuery,
    useGetDirectReporteesQuery,
} from './coachingHistoryGridSlice';

interface CoachingSummaryProps {
    date?: Date;
}

const CoachingHistoryGrid = (props: CoachingSummaryProps) => {
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [selectionMade, setSelectionMade] = useState(false);
    const [date, setDate] = useState(new Date());
    const [selectedTeam, setSelectedTeam] = useState<string>('myActivity');
    const [selectTeamList, setSelectTeamList] = useState<any>();
    const [selectMember, setSelectMember] = useState<any>();
    const [selectedEmpList, setSelectedEmpList] = useState<any>();
    const [selectedEmp, setSelectedEmp] = useState<any>();
    const [searchVisible, setSearchVisible] = useState<boolean>(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor=useSelector(selectIsPseudoSupervisor);
    const loggedEmpNum = useSelector(selectCurrentEmpid); //author number
    const [inputEmpNum, setInputEmpNum] = useState<any>(loggedEmpNum);
    const loggedEmpUser = useSelector(selectCurrentUser); //author name
    const [currentMonthSummary, setCurrentMonthSummary] = useState<any>(null);
    const [remainingMonthSummary, setRemainingMonthSummary] = useState<any>(null);
    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
        'employee_name': '',
        'employee_number': '',
        'location': '',
        'job_title': '',
    });
    const [viewState, setViewState] = useState<string>('read');
    const [displayModal, setDisplayModal] = useState(false);
    const [recieverId, setRecieverId] = useState<string>('');
    const [receiverName, setReceiverName] = useState<string>('');
    const [strength, setStrength] = useState<StrengthList | undefined>(undefined);
    const [parentStrengthViewState, setParentStrengthViewState] = useState('');

    const [showConversationModal, setShowConversationModal] = useState<boolean>(false);
    const [showStrengthModal, setShowStrengthModal] = useState<boolean>(false);

    const [showGoalsModal, setShowGoalsModal] = useState<boolean>(false);
    const [showMetricModal, setShowMetricModal] = useState<boolean>(false);
    const [selectedMonth, setSelectedMonth] = useState<any>();
    const [selectedYear, setSelectedYear] = useState<any>();
    const [showRevGenGoalSummary, setShowRevGenGoalSummary] = useState<boolean>(false);
    const [revgenList, setRevgenList] = useState<any[]>([]);
    const { data: directReportees } = useGetDirectReporteesQuery(
        {
            employeeNo: parseInt(loggedEmpNum, 10),
        },
        {
            skip: !loggedEmpNum,
        }
    );
    const { data: coachingGoals, isFetching: coachingGoalsFetching } = useGetRevGenCoachingGoalQuery(
        {
            authorId: loggedEmpNum,
            recipientId: selectedTeam === 'myTeamActivity' ? loggedEmpNum : recieverId,
            year: selectedYear,
            month: selectedMonth,
            teamOption: selectedTeam === 'myTeamActivity' ? 'expand' : 'mygoals',
            role: getRole(userManagerLevel,isPseudoSupervisor),
        },
        {
            skip: !loggedEmpNum || !selectedYear || !selectedMonth || !showGoalsModal,
        }
    );
    const [displayName, setDisplayName] = useState<string>('');
    useEffect(() => {
        const list = [{ value: 'myActivity', label: 'My Activity' }];
        if (isPseudoSupervisor===true||ROLES.SupervisorORManager.includes(userManagerLevel)) {
            const directReporteOptions = [
                { value: 'myTeamActivity', label: 'My Team’s Activity' },
                { value: 'search', label: 'Search' },
            ];
            list.push(...directReporteOptions);
        }
        setSelectTeamList(list);
        setSelectMember(false);
        setDisplayName(loggedEmpUser);
        setSelectionMade(true);
    }, []);
    useEffect(() => {
        if (coachingGoals?.data?.length > 0) {
            if (selectedTeam === 'myTeamActivity' && ROLES.Manager.includes(userManagerLevel)) {
                const filterOutOwnRec = coachingGoals?.data?.filter(
                    (record: any) => record.employee_number !== loggedEmpNum
                );
                setRevgenList(filterOutOwnRec);
            } else {
                setRevgenList(coachingGoals?.data);
            }
        }
    }, [coachingGoals]);

    useEffect(() => {
        const selecedTeam = localStorage.getItem('selectedTeam');
        if (selecedTeam && selectTeamList?.some((item: any) => item.value === selecedTeam)) {
            setSelectedTeam(selecedTeam);
        }
        if (selecedTeam === 'myActivity') {
            setInputEmpNum(loggedEmpNum);
            setSelectMember(false);
        }
        if (selecedTeam === 'myTeamActivity') {
            setSelectMember(true);
            if (directReportees?.data.length > 0) {
                const searchedTeamMemberValue = localStorage.getItem('searchedTeamMember');
                if (searchedTeamMemberValue) {
                    const data = directReportees?.data.find(
                        (item: any) => item.employee_number === parseInt(searchedTeamMemberValue, 10)
                    );
                    if (data) {
                        setTimeout(() => {
                            setInputEmpNum(data.employee_number);
                            setDisplayName(data.employee_name);
                            setSelectedEmp(data.employee_number);
                        }, 50);
                    } else {
                        setInputEmpNum('');
                        setSelectedEmp('');
                    }
                }
            }
        }
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeam === 'search') {
            if (searchedUserString) {
                const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                setSearchVisible(false);
                setSearchedEmployee(searchedUser);
                setInputEmpNum(searchedEmployee.employee_number);
                setSelectedEmp(searchedEmployee.employee_number);
                handleSelectedEmployee(searchedUser);
            } else {
                setSearchVisible(true);
            }
        }
    }, [selectedTeam, directReportees, selectTeamList]);

    useEffect(() => {
        if (directReportees?.data && Array.isArray(directReportees.data)) {
            const employeeNames = directReportees.data.map((employee: any) => ({
                label: employee.employee_name,
                value: employee.employee_number,
            }));

            setSelectedEmpList(employeeNames);
        }
    }, [directReportees]);

    useEffect(() => {
        if (selectedTeam === 'myActivity') {
            setInputEmpNum(loggedEmpNum);
        }
    }, [selectedTeam, setInputEmpNum, loggedEmpNum]);

    const { 
        data: currentMonthActivityData,
        isLoading: isLoadingCurrentMonth,
        isFetching: isFetchingCurrentMonth,
        isError: isErrorCurrentMonth
    } = useGetCurrentMonthAcitivityQuery(
        {
            empNumber: parseInt(inputEmpNum, 10),
            loggedEmpNumber: parseInt(loggedEmpNum, 10),
        },
        {
            skip: !inputEmpNum,
        }
    );

    const { 
        data: activitySummaryData,
        isLoading: isLoadingActivitySummary,
        isFetching: isFetchingActivitySummary,
        isError: isErrorActivitySummary
    } = useGetActivitySummaryQuery(
        {
            empNumber: parseInt(inputEmpNum, 10),
            loggedEmpNumber: parseInt(loggedEmpNum, 10),
            year: inputYear,
        },
        {
            skip: !inputEmpNum || !inputYear,
        }
    );

    useEffect(() => {
        if (isErrorCurrentMonth) {
            toast.error('Failed to load current month activity. Please try again.');
        }
    }, [isErrorCurrentMonth]);

    useEffect(() => {
        if (isErrorActivitySummary) {
            toast.error('Failed to load coaching history. Please try again.');
        }
    }, [isErrorActivitySummary]);

    useEffect(() => {
        if (currentMonthActivityData?.data.length > 0) {
            setCurrentMonthSummary(currentMonthActivityData?.data);
        } else {
            setCurrentMonthSummary([]);
        }
    }, [currentMonthActivityData]);

    useEffect(() => {
        if (activitySummaryData?.data.length > 0) {
            setRemainingMonthSummary(activitySummaryData.data);
        } else {
            setRemainingMonthSummary([]);
        }
    }, [activitySummaryData]);

    const getEmptyMessage = (isError: boolean, selectionMade: boolean, errorMsg: string, noDataMsg: string, defaultMsg: string) => {
        if (isError) return errorMsg;
        if (selectionMade) return noDataMsg;
        return defaultMsg;
    };

    const headerTemplate = (header: string, colorcode: string) => {
        return (
            <>
                <div
                    className="header-container"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '60px',
                        textAlign: 'center',
                        position: 'relative',
                    }}
                >
                    {header === 'strengths' && (
                        <div className="strengths-tool">
                            <img src={Strengths} alt="Strengths" />{' '}
                            <span style={{ color: colorcode }} className="header-text">
                                Strengths
                            </span>
                        </div>
                    )}
                    {header === 'discussion-logs' && (
                        <div className="discussion-tool">
                            <img src={DiscussionLogs} alt="Discussion Logs" />
                            <span style={{ color: colorcode }} className="header-text">
                                Discussions
                            </span>
                        </div>
                    )}
                    {header === 'metric-review' && (
                        <div className="metric-tool">
                            <img src={MetricReview} alt="Metric Review" />{' '}
                            <span style={{ color: colorcode }} className="header-text">
                                Metric Review
                            </span>
                        </div>
                    )}
                    {header === 'goals' && (
                        <div>
                            <img src={Goals} alt="Goals" />
                            <span style={{ color: colorcode }} className="header-text">
                                Goals
                            </span>
                        </div>
                    )}
                    <span className={`${header} question-circle margin-left-8 `}>
                        <i className="pi pi-question" style={{ color: 'white' }} />
                    </span>
                </div>
                {header === 'strengths' && (
                    <Tooltip target={`.${header}`} position="top">
                        <div id="coachingSummary" className="tooltip-content">
                            <span
                                style={{ minWidth: '1rem', display: 'flex', justifyContent: 'space-between' }}
                            >
                                {TOOLTIPSTRENGTH}
                            </span>
                        </div>
                    </Tooltip>
                )}
                {header === 'discussion-logs' && (
                    <Tooltip target={`.${header}`} position="top">
                        <div id="coachingSummary" className="tooltip-content">
                            <span
                                style={{ minWidth: '1rem', display: 'flex', justifyContent: 'space-between' }}
                            >
                                {TOOLTIPDISCUSSION}
                            </span>
                        </div>
                    </Tooltip>
                )}
                {header === 'metric-review' && (
                    <Tooltip target={`.${header}`} position="top">
                        <div id="coachingSummary" className="tooltip-content">
                            <span
                                style={{ minWidth: '1rem', display: 'flex', justifyContent: 'space-between' }}
                            >
                                {TOOLTIPMETRIC}
                            </span>
                        </div>
                    </Tooltip>
                )}

                <hr style={{ color: colorcode }} className="border-header" />
                {header === 'Coaching 1 on 1' && <p>Discussion</p>}
            </>
        );
    };

    const handleGridButonClick = (
        employeeNumber: string,
        columnName: string,
        isEdit: boolean,
        receiverName: string,
        month: number,
        year: number
    ) => {
        setRecieverId(employeeNumber);
        setReceiverName(receiverName);
        setDisplayModal(true);
        setSelectedMonth(month);
        setSelectedYear(year);
        if (columnName === 'logs') {
            setViewState(isEdit ? 'read' : 'new');
            setShowMetricModal(false);
            setParentStrengthViewState(isEdit ? 'read' : 'new');
            setShowConversationModal(true);
            setShowStrengthModal(false);
            setShowGoalsModal(false);
        } else if (columnName === 'metrics') {
            if (!isEdit && loggedEmpNum === employeeNumber) {
                toast.warning('You cannot create your own Metric Review.');
                setShowConversationModal(false);
                setShowStrengthModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
                setShowRevGenGoalSummary(false);
            } else {
                setShowConversationModal(false);
                setShowStrengthModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(true);
                setShowRevGenGoalSummary(false);
            }
        } else if (columnName === 'goals') {
            setShowConversationModal(false);
            setShowStrengthModal(false);
            setParentStrengthViewState(isEdit ? 'read' : 'new');
            setViewState(isEdit ? 'read' : 'new');
            setShowMetricModal(false);
            setShowGoalsModal(true);
            setShowRevGenGoalSummary(true);
        } else if (columnName === 'strengths') {
            if (!isEdit && loggedEmpNum === employeeNumber) {
                toast.warning('You cannot create your own strengths');
                setViewState('');
                setParentStrengthViewState('');
                setShowStrengthModal(false);
                setShowConversationModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
                setShowRevGenGoalSummary(false);
            } else {
                setViewState(isEdit ? 'read' : 'new');
                setParentStrengthViewState(isEdit ? 'read' : 'new');
                setShowStrengthModal(true);
                setShowConversationModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
                setShowRevGenGoalSummary(false);
            }
        }
    };

    const buttonTemplate = (rowData: any, columnName: string, dividerColor: string) => {
        const color = rowData[columnName] ? '#2AA154' : '#3F5765';
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    {rowData[columnName] && (
                        <Button
                            type="button"
                            data-testid="buttonTemplate"
                            icon={'pi pi-eye'}
                            style={{
                                background: 'transparent',
                                border: `${color} 1px solid`,
                                color: `${color}`,
                                width: '30px',
                                height: '30px',
                            }}
                            onClick={() => {
                                handleGridButonClick(
                                    rowData.employee_number,
                                    columnName,
                                    rowData[columnName],
                                    rowData.employee_name,
                                    rowData.month,
                                    rowData.year
                                );
                            }}
                        />
                    )}
                </div>
                <div style={{ background: `${dividerColor}`, height: '2px', margin: '10px 0px' }}>&nbsp;</div>
            </div>
        );
    };
    const currentMonthbuttonTemplate = (rowData: any, columnName: string, dividerColor: string) => {
        const color = rowData[columnName] ? '#2AA154' : '#3F5765';
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Button
                        type="button"
                        icon={rowData[columnName] ? 'pi pi-pencil' : 'pi pi-plus'}
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                        }}
                        onClick={() => {
                            handleGridButonClick(
                                rowData.employee_number,
                                columnName,
                                rowData[columnName],
                                rowData.employee_name,
                                rowData.month,
                                rowData.year
                            );
                        }}
                    />
                </div>
                <div style={{ background: `${dividerColor}`, height: '2px', margin: '10px 0px' }}>&nbsp;</div>
            </div>
        );
    };

    const DateOnChange = (e: any) => {
        setDate(e.value);
        setYear(e.value.getFullYear());
    };

    const renderConversationLog = () => {
        if (viewState === 'read') {
            return (
                <ReadConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    viewState={viewState}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    inputYear={selectedYear}
                    inputMonth={selectedMonth}
                    via={CoachingTabs.History}
                    readOnly={!((selectedMonth === new Date().getMonth() + 1) && (selectedYear === new Date().getFullYear()))}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    viewState={viewState}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    via={CoachingTabs.History}
                    date={props.date}
                    coachingEntityId={0}
                    coachingEntityTypeId={CoachingEntityTypes.General}
                />
            );
        }
        return '';
    };

    const renderStrenghtsModals = () => {
        if (viewState === 'read') {
            return (
                <ReadStrengths
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    OnEditStrength={setStrength}
                    year={selectedYear}
                    month={selectedMonth}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewStrength
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    parentStrengthViewState={parentStrengthViewState}
                    coachingEntityTypeId={CoachingEntityTypes.General}
                    coachingEntityId={0}
                />
            );
        } else if (viewState === 'edit') {
            return (
                <UpdateStrength
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    displayModal={displayModal}
                    strength={strength}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                />
            );
        }
        return '';
    };
    const closeDialog = (res: boolean) => {
        setShowRevGenGoalSummary(!res);
        setShowGoalsModal(!res);
    };
    const renderGoals = () => {
        const recipentDetails = {
            employee_number: recieverId,
        };
        return (
            <RevGenSummary
                recipientDetails={recipentDetails}
                inputMonth={selectedMonth}
                inputYear={selectedYear}
                visible={showRevGenGoalSummary}
                revgenList={revgenList}
                closeDialog={closeDialog}
                viewState={
                    selectedMonth === new Date().getMonth() + 1 && selectedYear === new Date().getFullYear()
                        ? 'new'
                        : 'read-only'
                }
            />
        );
    };

    const renderMetric = () => {
        return (
            <MetricModal
                setDisplayModal={setDisplayModal}
                displayModal={displayModal}
                authorId={loggedEmpNum}
                recipientId={recieverId}
                inputYear={selectedYear}
                inputMonth={selectedMonth}
                recipientName={receiverName}
                entityTypeId={CoachingEntityTypes.General}
            />
        );
    };
    const handleSelectedEmployee = (selectedEmployee: any) => {
        setInputEmpNum(selectedEmployee?.employee_number);
        setDisplayName(selectedEmployee?.employee_name || '');
    };

    return (
        <>
            <div className="row mt-4">
                {(isPseudoSupervisor===true||ROLES.SupervisorORManager.includes(userManagerLevel)) && (
                    <div className="col-md-3">
                        <div className="content" data-testid="select-team">
                            <label htmlFor="select-team">Select Team</label>
                            <Dropdown
                                id="select-team"
                                data-testid="select-team"
                                placeholder="Select Team"
                                className="custom-dropdown"
                                options={selectTeamList}
                                optionValue={'value'}
                                optionLabel={'label'}
                                value={selectedTeam}
                                onChange={(e) => {
                                    setSelectedTeam(e.target.value);
                                    localStorage.setItem('selectedTeam', e.target.value);
                                    localStorage.removeItem('searchedUser');
                                    if (e.target.value === 'search') {
                                        setSearchVisible(true);
                                        setSelectMember(false);
                                        setDisplayName(searchedEmployee?.employee_name);
                                        setSelectionMade(true);
                                        setSelectedEmp('');
                                    }
                                    if (e.target.value === 'myTeamActivity') {
                                        setSelectMember(true);
                                        setSelectedEmp('');
                                    }
                                    if (e.target.value === 'myActivity') {
                                        setSelectMember(false);
                                        setInputEmpNum(loggedEmpNum);
                                        setDisplayName(loggedEmpUser);
                                        setSelectionMade(true);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
                {selectMember && (
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="selectedEmp">Select Employee</label>
                            <Dropdown
                                id="selectedEmp"
                                name="Select Employee"
                                placeholder="Select Employee"
                                className="custom-dropdown"
                                options={selectedEmpList}
                                optionValue={'value'}
                                optionLabel={'label'}
                                value={selectedEmp}
                                onChange={(e) => {
                                    setSelectedEmp(e.target.value);
                                    setInputEmpNum(e.target.value);
                                    localStorage.setItem('searchedTeamMember', e.target.value);
                                    const selectedEmployee = selectedEmpList.find(
                                        (emp: any) => emp.value === e.target.value
                                    );
                                    setDisplayName(selectedEmployee?.label || '');
                                    setSelectionMade(true);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* current month */}

            <div className="row mt-4">
                <div>{displayName}</div>
                <DataTable
                    value={currentMonthSummary}
                    id="coaching-summary"
                    rows={1}
                    loading={isLoadingCurrentMonth || isFetchingCurrentMonth}
                    emptyMessage={getEmptyMessage(
                        isErrorCurrentMonth,
                        selectionMade,
                        'Error loading current month data. Please try again.',
                        'No records found for the current month.',
                        'No records found.'
                    )}
                >
                    <Column field="monthName" style={{ width: '12rem' }} />
                    <Column
                        header={headerTemplate('strengths', '#A9A5FF')}
                        field="strengths"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => currentMonthbuttonTemplate(rowData, 'strengths', '#A9A5FF')}
                    />
                    <Column
                        header={headerTemplate('discussion-logs', '#3299FF')}
                        field="logs"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => currentMonthbuttonTemplate(rowData, 'logs', '#3299FF')}
                    />
                    <Column
                        header={headerTemplate('metric-review', '#F93')}
                        field="metrics"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => currentMonthbuttonTemplate(rowData, 'metrics', '#F93')}
                    />
                    <Column
                        header={headerTemplate('goals', '#64D96E')}
                        field="goals"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => currentMonthbuttonTemplate(rowData, 'goals', '#64D96E')}
                    />
                </DataTable>
            </div>

            {/* all other months of year */}
            {selectionMade && (
                <div className="row mt-4">
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="selectyear">Select Year</label>
                            <Calendar
                                id="selectyear"
                                value={date}
                                onChange={DateOnChange}
                                view="year"
                                maxDate={new Date()}
                                className="custom-calendar"
                                showIcon
                                dateFormat="yy"
                                disabled={isLoadingActivitySummary || isFetchingActivitySummary}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '21px',
                            fontStyle: 'italic',
                        }}
                        className="col-md-9"
                    >
                        Coaching History
                    </div>

                    <DataTable
                        value={remainingMonthSummary}
                        id="coaching-summary"
                        loading={isLoadingActivitySummary || isFetchingActivitySummary}
                        emptyMessage={getEmptyMessage(
                            isErrorActivitySummary,
                            true,
                            'Error loading coaching history. Please try again.',
                            'No records found for the selected year.',
                            'No records found.'
                        )}
                    >
                        <Column field="monthName" style={{ width: '12rem' }} />
                        <Column
                            header={headerTemplate('strengths', '#A9A5FF')}
                            field="strengths"
                            style={{ width: '5rem' }}
                            body={(rowData: any) => buttonTemplate(rowData, 'strengths', '#A9A5FF')}
                        />
                        <Column
                            header={headerTemplate('discussion-logs', '#3299FF')}
                            field="logs"
                            style={{ width: '5rem' }}
                            body={(rowData: any) => buttonTemplate(rowData, 'logs', '#3299FF')}
                        />
                        <Column
                            header={headerTemplate('metric-review', '#F93')}
                            field="metrics"
                            style={{ width: '5rem' }}
                            body={(rowData: any) => buttonTemplate(rowData, 'metrics', '#F93')}
                        />
                        <Column
                            header={headerTemplate('goals', '#64D96E')}
                            field="goals"
                            style={{ width: '5rem' }}
                            body={(rowData: any) => buttonTemplate(rowData, 'goals', '#64D96E')}
                        />
                    </DataTable>
                </div>
            )}
            {searchVisible && (
                <ActivityEmployeeSearchPopUp
                    visible={searchVisible}
                    loggedEmpNumber={loggedEmpNum}
                    searchedEmpNumber={searchedEmployee}
                    setSearchedEmployee={setSearchedEmployee}
                    setVisible={setSearchVisible}
                    setSelectedTeam={setSelectedTeam}
                    onEmployeeSelected={handleSelectedEmployee}
                />
            )}

            {showConversationModal && renderConversationLog()}
            {showStrengthModal && renderStrenghtsModals()}
            {showGoalsModal && !coachingGoalsFetching && renderGoals()}
            {showMetricModal && renderMetric()}
        </>
    );
};

export default CoachingHistoryGrid;
